import React from "react";
import { IconButton } from "@mui/material";
import { Edit as EditIcon } from "@mui/icons-material";
import GridListItem from "components/common/grid/GridListItem";
import { getDateAndTimeWithAMPM } from "utils/date";

const EHRNote = ({ ehrNote, canEditEHRNote, handleEdit }) => {
  const { note, created_at, created_by, updated_at, updated_by } = ehrNote;
  const { date, time } = getDateAndTimeWithAMPM(updated_at || created_at);

  const noteUser = updated_by || created_by;
  const noteTitle =
    (noteUser ? noteUser?.name + " • " : "") + date + " • " + time;

  return (
    <GridListItem
      size={12}
      subTitle={note}
      title={noteTitle}
      secondaryAction={
        canEditEHRNote && (
          <IconButton
            edge="end"
            aria-label="edit-note"
            onClick={() => handleEdit(ehrNote)}
          >
            <EditIcon data-action="edit-ehr-note-icon" />
          </IconButton>
        )
      }
      gridProps={{ style: { backgroundColor: "#f5f5f5", borderRadius: "4px" } }}
    />
  );
};

export default EHRNote;
